import { Injectable } from '@angular/core';
import { Action } from '../../../section/master/model/action';
import { Prescription, MAppointmentAfterCall } from '../model/prescription';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { HttpClientService } from '../../../shared/service/http/http-client.service';
import { CookiesService } from '../../../shared/service/cookies/cookies.service';

@Injectable()
export class PrescriptionService {

  http:HttpClientService;
  cookie : CookiesService;
  objAction : Action;
  data : Prescription[];
  afterCall : MAppointmentAfterCall;
  vitalData : Prescription;
  PrescFile: any[];
  constructor(http: HttpClientService, cook: CookiesService) {
     this.http = http;
     this.cookie = cook;
     this.objAction  = new Action(this.http,  this.cookie);
  }
  savePrescription(): Observable<Prescription> {
    this.objAction.header = null;
    this.objAction.data = this.data;
    this.objAction.path = 'api/Prescription/CreatePatientPrescription';
    return this.objAction.save();
  }

  saveAfterCallData(): Observable<MAppointmentAfterCall> {
    this.objAction.header = null;
    this.objAction.data = this.afterCall;
    this.objAction.path = 'api/Prescription/SaveAfterCall';
    return this.objAction.save();
  }

  savePrescriptionCallData(): Observable<MAppointmentAfterCall> {
    this.objAction.header = null;
    this.objAction.data = this.afterCall;
    this.objAction.files = this.PrescFile;
    this.objAction.path = 'api/Prescription/SavePrescriptionWithFile';
    return this.objAction.saveDataWithFiles();
  }

 getPrescription(PatientId : number):   Observable<any> {
    this.objAction.path = 'api/Prescription/GetPatientPrescription?PatientId='+ PatientId;
    return this.objAction.get();
 }
 getPrescriptionForAppointment(PatientId : number, AppointmentId : number):   Observable<any> {
  this.objAction.path = 'api/Prescription/GetPatientPrescriptionForAppointment?PatientId='+ PatientId + '&AppointmentId='+ AppointmentId;
  return this.objAction.get();
}
getAfterCallData(AppointmentId : number):   Observable<any> {
  this.objAction.path = 'api/Prescription/GetAfterCallData?appointmentId='+ AppointmentId;
  return this.objAction.get();
}


 updatePrescription(): Observable<Prescription> {
    this.objAction.header = null;
    this.objAction.data = this.data;
    this.objAction.path = 'api/Prescription/UpdatePrescription';
    return this.objAction.update();
 }
 deletePrescription(usr: Prescription): Observable<Prescription> {
  this.objAction.header = null;
  this.objAction.path = 'api/Prescription/DeletePatientPrescription?strPatientId=' + usr.PatientId + "&strAppointmentId="+ usr.AppointmentId;
  return this.objAction.delete();
}
copyPrescription(usr: Prescription): Observable<Prescription> {
  this.objAction.header = null;
    this.objAction.data = usr;
    this.objAction.path = 'api/Prescription/CopyPatientPrescription';
  return this.objAction.save();
}

getGenericName(type : string, text: string):   Observable<any> {
  this.objAction.path = 'api/Drugs/GetGeneric?type='+type+'&text='+text;
  return this.objAction.get();
}

getDrugName(type : string, text: string):   Observable<any> {
  this.objAction.path = 'api/Drugs/GetDrugsByGeneric?type='+type+'&text='+text;
  return this.objAction.get();
}


}



// WEBPACK FOOTER //
// ./src/app/section/patient/service/prescription.service.ts